import React from 'react';

const STEPS = [
  { id: 'sbom',   icon: '📋', label: 'SBOM Available' },
  { id: 'health', icon: '🏥', label: 'Health Scanned' },
  { id: 'vulns',  icon: '🛡️', label: 'Vulnerabilities Scanned' },
  { id: 'policy', icon: '📋', label: 'Policy Evaluated' },
];

export default function WorkflowProgress({ hasSbom, hasHealth, hasVulns, hasPolicy }) {
  const states = { sbom: hasSbom, health: hasHealth, vulns: hasVulns, policy: hasPolicy };
  const stepIds = ['sbom', 'health', 'vulns', 'policy'];
  const doneCount = stepIds.filter(id => states[id]).length;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 0, padding: '0.75rem 1.25rem', background: 'var(--bs-tertiary-bg)', borderBottom: '1px solid var(--bs-border-color)' }}>
      {STEPS.map((step, i) => {
        const done = states[step.id];
        const isLast = i === STEPS.length - 1;
        return (
          <React.Fragment key={step.id}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <div style={{
                width: 28, height: 28,
                borderRadius: '50%',
                background: done ? 'var(--accent)' : 'var(--bs-tertiary-bg)',
                border: `2px solid ${done ? 'var(--accent)' : 'var(--bs-border-color)'}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 14, transition: 'all 0.3s',
              }}>
                {done ? '✓' : step.icon}
              </div>
              <div style={{ fontSize: '0.625rem', color: done ? 'var(--accent-text)' : 'var(--bs-secondary-color)', fontWeight: done ? 600 : 400, whiteSpace: 'nowrap' }}>
                {step.label}
              </div>
            </div>
            {!isLast && (
              <div style={{ flex: 1, height: 2, background: done ? 'var(--accent)' : 'var(--bs-border-color)', margin: '0 0.5rem', marginBottom: '1.1rem', transition: 'background 0.3s' }} />
            )}
          </React.Fragment>
        );
      })}
      <div style={{ marginLeft: 'auto', fontSize: '0.75rem', color: 'var(--bs-secondary-color)', paddingLeft: '1rem', whiteSpace: 'nowrap' }}>
        {doneCount}/{STEPS.length} complete
      </div>
    </div>
  );
}
